// Generated by BUCKLESCRIPT VERSION 3.1.5, PLEASE EDIT WITH CARE
'use strict';

var ReasonReact = require("reason-react/src/ReasonReact.js");
var ReactTimeago = require("react-timeago");

function make(date, children) {
  return ReasonReact.wrapJsForReason(ReactTimeago.default, {
              date: date
            }, children);
}

exports.make = make;
/* ReasonReact Not a pure module */



// WEBPACK FOOTER //
// ./src/bindings/TimeAgo.js